<template>
    <header :class="['header', {'highlight': tooltipsActive == 4 && !tooltipsSeenAll}]">
        <div class="grid grid--padding">
            <div class="header__wrapper">
                <router-link :to="{name: 'home'}" class="header__logo-wrapper">
                    <img src="@/assets/images/rastemo.svg" alt="RaSTEMo" class="header__logo" />
                </router-link>

                <div v-if="showPdfButton" class="header__btn-wrapper">
                    <a href="/e-prirucnik-za-clanove-ocd-ova-i-druge-dionike.pdf" target="_blank" class="btn btn--secondary">
                        <span>{{ $t('header.button-stem-text') }}</span>
                        <img src="@/assets/images/handbook-stem.svg" :alt="$t('header.button-stem-text')" class="header__icon" />
                        <div class="header__popover">
                            {{ $t('header.button-stem-popover') }}
                        </div>
                    </a>
                    <a href="/e-prirucnik-odrzive-gradnje.pdf" target="_blank" class="btn btn--secondary">
                        <span>{{ $t('header.button-text') }}</span>
                        <img src="@/assets/images/handbook.svg" :alt="$t('header.button-text')" class="header__icon" />
                        <div class="header__popover">
                            {{ $t('header.button-popover') }}
                        </div>
                    </a>
                </div>

                <router-link v-if="showBudgetButton" :to="{name: 'budget'}" class="header__budget">
                    <span>{{ budget }}</span>
                </router-link>

                <div v-if="!tooltipsSeenAll && tooltipsActive == 4" class="tooltip tooltip--top animate__animated animate__bounceInDown">
                    <div class="tooltip__progress">{{ tooltipsActive }} {{ $t('game.tooltip.text.of')}} {{ tooltipsTotalCount }}</div>
                    <div class="tooltip__text">{{ $t('game.tooltip.budget-instruction') }}</div>
                    <button @click="updateTooltips" class="btn btn--small btn--persimmon">{{ $t('button.next') }}</button>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: 'HeaderComponent',
    computed: {
        showPdfButton() {
            return this.$route.meta.pdfButton;
        },
        showBudgetButton() {
            return this.$route.meta.budgetButton;
        },
        budget() {
            return this.$store.getters['game/getBudgetFormatted'];
        },
        tooltipsTotalCount() {
            return this.$store.getters['game/getTooltipsTotalCount'];
        },
        tooltipsActive() {
            return this.$store.getters['game/getTooltipsActive'];
        },
        tooltipsSeenAll() {
            return this.$store.getters['game/getTooltipsSeenAll'];
        }
    },
    methods: {
        updateTooltips() {
            this.$store.commit('game/updateTooltips');
        }
    }
}
</script>
